import { cn } from "@newxsystems/shared";
import type { IAbyssSectionProps } from "./AbyssSection.props";

export const AbyssSection = ({
  children,
  className,
  containerClassName,
  containerWidth = "default",
  id,
  spacing,
}: IAbyssSectionProps) => (
  <section
    className={cn("abyss-block-spacing bg-background text-foreground", className)}
    data-spacing={spacing || undefined}
    id={id || undefined}
  >
    <div
      className={cn("abyss-container", containerClassName)}
      data-container-width={containerWidth}
    >
      {children}
    </div>
  </section>
);

AbyssSection.displayName = "Content::AbyssSection";
